import React from "react";
import { uninitializedContextErrorFn } from "shared/errors/UninitializedContextError";

export interface TableBoxContextValues {
  collapseRef: React.RefCallback<HTMLElement>;
  isCollapsible: boolean;
  isExpanded: boolean;
  isFullHeight: boolean;
  isFullWidth: boolean;
  isFullScreen: boolean;
  setFullScreen: (isFullScreen: boolean) => void;
  setTitle: (title: string) => void;
  title: string | undefined;
  toggleExpanded: () => void;
  tableBoxRef: React.RefObject<HTMLDivElement>;
}

export const throwUninitializedContextError =
  uninitializedContextErrorFn("TableBoxContext");

export const TableBoxContext = React.createContext<TableBoxContextValues>({
  collapseRef: throwUninitializedContextError,
  isCollapsible: false,
  isExpanded: false,
  isFullHeight: false,
  isFullScreen: false,
  isFullWidth: false,
  setFullScreen: throwUninitializedContextError,
  setTitle: throwUninitializedContextError,
  title: undefined,
  toggleExpanded: throwUninitializedContextError,
  tableBoxRef: { current: null },
});

export const useTableBoxContext = () => React.useContext(TableBoxContext);
